var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-table', {
    ref: "table",
    staticClass: "px-0",
    attrs: {
      "small": "",
      "bordered": "",
      "striped": "",
      "hover": "",
      "fields": _vm.fields,
      "items": _vm.users.data,
      "per-page": _vm.users.pageSize,
      "current-page": _vm.$route.path.includes('/group/users') ? _vm.page : '',
      "page": _vm.page,
      "busy": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function() {
        return [_c('div', {
          staticClass: "text-center text-primary my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        }), _vm._v(" "), _c('strong', [_vm._v("Loading...")])], 1)]
      },
      proxy: true
    }, {
      key: "cell()",
      fn: function(ref) {
        var value = ref.value;
        var item = ref.item;
        var index = ref.index;
        var key = ref.field.key;

        return [(_vm.showEdit(index)) ? [_vm._v(_vm._s(value))] : _c('b-form-input', {
          staticClass: "py-0 px-1 form-control-sm",
          model: {
            value: (item[key]),
            callback: function($$v) {
              _vm.$set(item, key, $$v)
            },
            expression: "item[key]"
          }
        })]
      }
    }, {
      key: "cell(clients)",
      fn: function(data) {
        return [_c('button', {
          staticClass: "text-primary",
          on: {
            "click": function($event) {
              return _vm.redirectToClients(data)
            }
          }
        }, [_vm._v("View Clients")])]
      }
    }, {
      key: "cell(users)",
      fn: function(data) {
        return [_c('button', {
          staticClass: "text-primary",
          on: {
            "click": function($event) {
              return _vm.redirectToGroupUsers(data)
            }
          }
        }, [_vm._v("View Users")])]
      }
    }, {
      key: "cell(owner)",
      fn: function(data) {
        return [_c('p', [_vm._v(_vm._s(data.item.owner.name))])]
      }
    }, {
      key: "cell(sharedWith)",
      fn: function(data) {
        return [_c('ul', [_c('ul', _vm._l((data.value), function(shared) {
          return _c('li', {
            staticClass: "spnod-admin__form--list"
          }, [_vm._v("\n            " + _vm._s(_vm.genSharedWith(shared)) + "\n          ")])
        }), 0)])]
      }
    }, {
      key: "cell(cancel)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "d-flex justify-content-center"
        }, [(data.value) ? _c('button', {
          staticClass: "cancel-button",
          on: {
            "click": function($event) {
              return _vm.$emit('handleCancel', data)
            }
          }
        }, [_vm._v("Cancel")]) : _vm._e()])]
      }
    }, {
      key: "cell(parents)",
      fn: function(data) {
        return [_c('ul', _vm._l((data.value), function(parent) {
          return _c('li', {
            staticClass: "spnod-admin__form--list"
          }, [_vm._v(_vm._s(parent.name))])
        }), 0)]
      }
    }, {
      key: "cell(actions)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "d-flex justify-content-center align-items-center"
        }, [_c('div', {
          staticClass: "d-flex justify-content-center"
        }, [(_vm.hasAction('accountMgmt')) ? _c('button', {
          staticClass: "mx-1",
          on: {
            "click": function($event) {
              return _vm.redirectToUserAccount(data)
            }
          }
        }, [_c('b-icon-person-fill', {
          attrs: {
            "title": "User Account"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.hasAction('inlineEdit')) ? _c('button', {
          staticClass: "mx-1",
          on: {
            "click": function($event) {
              return _vm.toggleInlineEdit(data)
            }
          }
        }, [(_vm.showEdit(data.index)) ? _c('b-icon-pencil-square', {
          attrs: {
            "title": "Edit"
          }
        }) : _c('b-icon-check-circle', {
          attrs: {
            "title": "Update"
          },
          on: {
            "click": function($event) {
              return _vm.$emit('handleUpdate', data)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.hasAction('delete')) ? _c('button', {
          staticClass: "mx-1",
          on: {
            "click": function($event) {
              return _vm.$emit('handleDelete', data)
            }
          }
        }, [_c('b-icon-trash-fill', {
          attrs: {
            "title": "Delete"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.hasAction('groupEdit')) ? _c('button', {
          staticClass: "mx-1",
          on: {
            "click": function($event) {
              return _vm.handleGroupEdit(data)
            }
          }
        }, [_c('b-icon-pencil-square', {
          attrs: {
            "title": "Edit"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.hasAction('download')) ? _c('a', {
          staticClass: "mx-1 text-dark",
          attrs: {
            "href": data.item.download,
            "target": "_blank"
          }
        }, [_c('b-icon-cloud-download', {
          attrs: {
            "title": "Download"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.hasAction('fileEdit') && (_vm.getMyInfo.hasRoles || data.item.owner._id === _vm.getMyInfo._id)) ? _c('button', {
          staticClass: "mx-1",
          on: {
            "click": function($event) {
              return _vm.handleFileEdit(data)
            }
          }
        }, [_c('b-icon-pencil-square', {
          attrs: {
            "title": "Edit"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.hasAction('subscriptionEdit')) ? _c('button', {
          staticClass: "mx-1",
          on: {
            "click": function($event) {
              return _vm.handleSubscriptionEdit(data)
            }
          }
        }, [_c('b-icon-pencil-square', {
          attrs: {
            "title": "Edit"
          }
        })], 1) : _vm._e()])])]
      }
    }])
  }), _vm._v(" "), (_vm.users.total > _vm.users.pageSize) ? _c('b-pagination', {
    staticClass: "mb-2",
    attrs: {
      "total-rows": _vm.users.total,
      "per-page": _vm.users.pageSize,
      "page": _vm.page,
      "aria-controls": "my-table",
      "size": "sm"
    },
    on: {
      "change": _vm.handleChange
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1154994b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/AdminTable.vue
// module id = icvP
// module chunks = 2